<template>
    <div>
        <table v-observe-visibility="popup_shopping_cart_open" style="font-size: .65rem;" id="popup_shopping_cart_table" class="display">
            <thead>
                
            </thead>
            <tbody>
                <tr>

                </tr>
                <tr>

                </tr>
            </tbody>
        </table>
        
    </div>
</template>
<script>
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

import axios from 'axios'
import AxiosStorage from 'axios-storage'
import api from '../../static/api.config.js'

import session from 'sessionstorage'

import { store } from '../storage/vuex-store.js' 

import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'


 

export default {
    name: 'popup_shopping_cart_datatable',
    props: {
        shopping_cart_location: String
    },
    methods:{
        ...mapGetters([
			'shopping_cart_count'
		]),
		...mapMutations([
			'set_authenticated',
			'set_user_session',
			'set_plant_info',
			'set_subdomain',
			'set_shopping_cart_count'
		]),
		...mapActions([
			'set_user_session',
			'set_plant_info',
			'set_shopping_cart_count'
		]),

        popup_shopping_cart_open(isVisible, entry){
            var open = false;

            if(isVisible){
                open = true
            }else{
                open = false
            }


            if(isVisible){
                console.log('popup open')
                var user_session = session.getItem('user')

                var request_package = {
                                        'request_package' : {
                                            'user':{
                                                'id': user_session.id
                                            }
                                        }
                                    }

                var table = jQuery('#popup_shopping_cart_table').DataTable()
                

                table.ajax.reload()
            }
        },

        remove_from_cart(item_id){
            var vthis = this;

            var user_session = JSON.parse(session.getItem('user'))

            var request_package = {
                                    'request_package' : {
                                        'remove': {
                                            'product': {
                                                'id' : item_id
                                            }
                                        },
                                        'user': user_session
                                    }
                                }



            try {
                axios.post(api.URL + '/api/shopping_cart/remove',  request_package)
                .then(function(){
                    var table = jQuery('#popup_shopping_cart_table').DataTable()
                    table.destroy()
                    
                    table = jQuery('#popup_shopping_cart_table').DataTable({
                        dom: "",
                        'paging': true,
                        'processing': true,
                        'serverSide': true,
                        "ajax": {
                            "url": api.URL + "/dtapi/shopping_cart/get", //API
                            "type": "POST",
                            "data": request_package
                        },
                        "columns": [
                            { "data": "shopping_cart.description" },
                            { "data": "shopping_cart.quantity" },
                            {
                                data: null,
                                className: "center",
                                "render": function(data, type, full, meta){
                                    var item_id = data.shopping_cart.id;
                                    return '<div class="align-center"><button id="remove_from_cart" item_id="'+item_id+'" class="editor_edit btn red" title="Remove"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash fa-w-14"><path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" class=""></path></svg></button></div>'

                                }
                            }
                        ],
                        "columnDefs": [
                            { targets: [0,1,2], orderable: false }
                        ]
                    })

                    table.ajax.reload()
                    vthis.$store.dispatch('set_shopping_cart_count')
                })
                

                
            } catch(error){
                throw error;
            }
            
        },

        add_to_cart(product_designnumber, product_quantity){

            var user_session = JSON.parse(session.getItem('user'))
            

            var request_package = {
                                    'request_package' : {
                                        'add': {
                                            'product': {
                                                'designnumber': product_designnumber,
                                                'quantity': parseInt(product_quantity)
                                            }
                                        },
                                        'user':{
                                            'id': user_session.id
                                        }
                                    }
                                }
                                

            try {
                const { data } = axios.post(api.URL + '/api/shopping_cart/add',  request_package);
                this.shopping_cart = data;
                console.log(this.shopping_cart)

            
            } catch(error){
                throw error;
            }

            this.$store.dispatch('set_shopping_cart_count')
            
        }



        
    },
    components:{

    },
    data: function(){
        return{
            shopping_cart: ''
        }
        
    },
    created: function(){


        
    },
    mounted: function(){

        var editor;
        var vthis = this;


        jQuery(document).ready(function(){
            var user_session = JSON.parse(session.getItem('user'))
            

            var request_package = {
                                    'request_package' : {
                                        'user': user_session
                                    }
                                    
                                }

            console.log(request_package)
            

            editor = new jQuery.fn.dataTable.Editor({
                ajax: {
                    "type":"POST",
                    "url": api.URL + "/dtapi/shopping_cart/get",
                    "data": request_package
                },
                table: this.shopping_cart_table,
                fields: [
                    {
                    
                        label: "Product",
                        name: "shopping_cart.description",
                        type: "readonly"
                    },
                    {
                        label: "Quantity",
                        name: "shopping_cart.quantity"
                        
                    
                    }
                ]
            })



            jQuery('#popup_shopping_cart_table').on( 'click', 'tbody td', function (e) {


                var target_cell = e.currentTarget.cellIndex
                var item_id = e.currentTarget.childNodes[0].childNodes[0].attributes[1].value
                console.log(target_cell)
                console.log(e)

                if(target_cell === 2){

                    console.log('item 3 clicked')

                    vthis.remove_from_cart(item_id)


                }else{
                
                    editor.inline( this , {
                        onBlur: 'submit'
                    } );    
                }




                 
            } );


            jQuery('#popup_shopping_cart_table').DataTable({
                

                dom: "",
                'orderable': false,
                'paging': true,
                'processing': true,
                'serverSide': true,
                "ajax": {
                    "url": api.URL + "/dtapi/shopping_cart/get", //API
                    "type": "POST",
                    "data": request_package
                },
                "columns": [
                    { "data": "shopping_cart.description" },
                    { "data": "shopping_cart.quantity" },
                    {
                        data: null,
                        className: "center",
                        "render": function(data, type, full, meta){
                            var item_id = data.id;
                            console.log(item_id)
                            return '<div class="align-center"><button id="remove_from_cart" item_id="'+item_id+'" class="editor_edit btn red" title="Remove"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash fa-w-14"><path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" class=""></path></svg></button></div>'

                        }
                    }
                ],
                "columnDefs": [
                    { targets: [0,1,2], orderable: false }
                ]
            })

            
        });



        // jQuery('#popup_shopping_cart').


    }
}

</script>
 


// WEBPACK FOOTER //
// src/datatables/popup_shopping_cart_datatable.vue